export const PHONE_NUMBER_E164 = '+48509567388';
export const PHONE_NUMBER_DISPLAY = '+48 509 567 388';
